import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

const sports = [
  { name: "Soccer", img: "https://images.unsplash.com/photo-1560272564-c83b66b1ad12?crop=entropy&cs=srgb&fm=jpg&w=600&q=80" },
  { name: "Basketball", img: "https://images.unsplash.com/photo-1612768875331-0447b960fa40?crop=entropy&cs=srgb&fm=jpg&w=600&q=80" },
  { name: "Football", img: "https://images.unsplash.com/photo-1488474739786-757973c2dff6?crop=entropy&cs=srgb&fm=jpg&w=600&q=80" },
  { name: "Baseball", img: "https://images.unsplash.com/photo-1529768167801-9173d94c2a42?crop=entropy&cs=srgb&fm=jpg&w=600&q=80" },
  { name: "Volleyball", img: "https://images.unsplash.com/photo-1686753767715-37cb0c34212c?crop=entropy&cs=srgb&fm=jpg&w=600&q=80" },
  { name: "Hockey", img: "https://images.unsplash.com/photo-1516226415502-d6624544376b?crop=entropy&cs=srgb&fm=jpg&w=600&q=80" },
  { name: "Lacrosse", img: "https://images.unsplash.com/photo-1746826092606-ffbcac530b89?crop=entropy&cs=srgb&fm=jpg&w=600&q=80" },
  { name: "Sports Performance", img: "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?crop=entropy&cs=srgb&fm=jpg&w=600&q=80" },
];

export default function Landing() {
  return (
    <div>
      <section className="grid md:grid-cols-2 gap-10 py-12 md:py-20 items-center">
        <div>
          <div className="rs-underline mb-6" />
          <h1 data-testid="landing-hero-h1" className="font-display-heavy text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">
            SNAP A REP.<br/>GET COACHED.
          </h1>
          <p className="mt-6 text-lg text-neutral-300 max-w-lg">
            Upload a short clip. Our AI coach breaks down your form, calls out fixable mistakes, and prescribes drills that actually stick.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/register"><Button data-testid="landing-cta-primary" className="h-14 px-8 text-base bg-red-600 hover:bg-red-700 font-semibold">Start free — 3 clips / month</Button></Link>
            <Link to="/pricing"><Button data-testid="landing-cta-secondary" variant="outline" className="h-14 px-8 text-base border-neutral-700 text-white hover:bg-neutral-900">See pricing</Button></Link>
          </div>
          <p className="mt-4 text-sm text-neutral-500">No card needed. Videos private by default.</p>
        </div>
        <div className="relative">
          <div className="aspect-video rounded-lg overflow-hidden border border-neutral-800">
            <img alt="Athlete in action" src="https://images.unsplash.com/photo-1560272564-c83b66b1ad12?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-4 -left-4 bg-neutral-900 border border-neutral-800 rounded-md px-4 py-3">
            <div className="text-xs uppercase text-neutral-400 font-display tracking-widest">Latest fix</div>
            <div className="font-display-heavy text-xl mt-1 text-white">Elbow drift on jump shot</div>
          </div>
          <div className="absolute -top-4 -right-4 bg-red-600 rounded-md px-4 py-3">
            <div className="text-xs uppercase text-white/80 font-display tracking-widest">Drill</div>
            <div className="font-display-heavy text-xl mt-1 text-white">3×15 wall-forms</div>
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="rs-underline mb-4" />
        <h2 className="font-display-heavy text-3xl sm:text-4xl">EVERY SPORT WE COACH</h2>
        <p className="text-neutral-400 mt-2 max-w-lg">Pick your sport at upload. We'll apply the right coaching lens.</p>
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
          {sports.map((s) => (
            <div key={s.name} data-testid={`sport-card-${s.name.toLowerCase().replace(/ /g, "-")}`} className="relative aspect-[4/5] rounded-md overflow-hidden border border-neutral-800 group">
              <img alt={s.name} src={s.img} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
              <div className="absolute bottom-3 left-3 font-display-heavy text-xl">{s.name}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-12">
        <div className="rs-underline mb-4" />
        <h2 className="font-display-heavy text-3xl sm:text-4xl">HOW IT WORKS</h2>
        <div className="mt-8 grid md:grid-cols-3 gap-6">
          {[
            { n: "01", t: "Upload a clip", d: "Up to 90 seconds. Tag yourself in the footage." },
            { n: "02", t: "AI reviews you", d: "Sport-specific coaching lens on the tagged player." },
            { n: "03", t: "Get fixes + drills", d: "Plain-language callouts. Drills you'll actually do." },
          ].map((x) => (
            <div key={x.n} className="border border-neutral-800 rounded-md p-6 bg-neutral-900">
              <div className="font-display-heavy text-red-500 text-2xl">{x.n}</div>
              <div className="font-display-heavy text-2xl mt-2">{x.t}</div>
              <div className="text-neutral-400 mt-2">{x.d}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
